export default __webpack_public_path__ + "static/media/skolanalysis-01.13c64fb8.png";